import StytchErrorMessage from './StytchErrorMessage';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class BaseEmailPasswordPage {
    public static readonly emailInputId = 'login-email';
    public static readonly passwordInputId = 'login-password';
    public static readonly signInButtonId = 'sign-in-button';
    public static readonly errorMessageId = StytchErrorMessage.errorMessageId;
}

export default BaseEmailPasswordPage;
